"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeadParagraph = exports.Title = exports.ClassicHeader = void 0;

var _palette = require("@artsy/palette");

var _ClassicByline = require("../../Byline/ClassicByline");

var _ClassicPromotedContent = require("./Components/ClassicPromotedContent");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassicHeader = function ClassicHeader(props) {
  var article = props.article,
      date = props.date,
      editTitle = props.editTitle,
      editLeadParagraph = props.editLeadParagraph;
  return _react.default.createElement(_react.default.Fragment, null, (article.partner || article.sale) && _react.default.createElement(_ClassicPromotedContent.ClassicPromotedContent, {
    article: article
  }), _react.default.createElement(_palette.Flex, {
    flexDirection: "column",
    my: (0, _palette.space)(4),
    mx: "auto",
    px: [(0, _palette.space)(2), 0],
    alignItems: ["left", "center"],
    maxWidth: ["580px", "900px"]
  }, _react.default.createElement(Title, {
    size: ["8", "10"],
    pb: (0, _palette.space)(3),
    textAlign: ["left", "center"]
  }, editTitle || _react.default.createElement("h1", null, article.title)), editLeadParagraph ? _react.default.createElement(LeadParagraph, {
    size: "4"
  }, editLeadParagraph) : article.lead_paragraph && _react.default.createElement(LeadParagraph, {
    size: "4"
  }, _react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: article.lead_paragraph
    }
  })), _react.default.createElement(_ClassicByline.ClassicByline, {
    article: article,
    date: date
  })));
};

exports.ClassicHeader = ClassicHeader;
var Title = (0, _styledComponents.default)(_palette.Serif).withConfig({
  displayName: "ClassicHeader__Title",
  componentId: "r7h3-0"
})([""]);
exports.Title = Title;
var LeadParagraph = (0, _styledComponents.default)(_palette.Serif).withConfig({
  displayName: "ClassicHeader__LeadParagraph",
  componentId: "r7h3-1"
})(["max-width:580px;width:100%;margin:0 auto;padding-bottom:", "px;font-style:italic;text-align:left;p{margin:0;}"], (0, _palette.space)(3));
exports.LeadParagraph = LeadParagraph;
//# sourceMappingURL=ClassicHeader.js.map